module.exports = __webpack_public_path__ + "static/media/scan-qr-licence-scanner.6b6d2a18.png";